module.exports = __webpack_public_path__ + "img/new_year_2026.5b775d1f.webp";